import { render, staticRenderFns } from "./ProjsAll.vue?vue&type=template&id=54de0492&scoped=true&"
import script from "./ProjsAll.vue?vue&type=script&lang=js&"
export * from "./ProjsAll.vue?vue&type=script&lang=js&"
import style0 from "./ProjsAll.vue?vue&type=style&index=0&id=54de0492&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54de0492",
  null
  
)

export default component.exports